module.exports = __webpack_public_path__ + "static/wizards-017d2db0acd3aab379974fd312e9d784.png";